import SeatPreferences from './SeatPreferences';

export default SeatPreferences;
